import { useMutation, useQueryClient } from 'react-query';

import { linkedEntitiesQueryKey } from 'src/Hooks/Queries/useFetchLinkedEntities';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { entityLinksApi } from 'src/Services/API';
import { LinkableEntityType, LinkedEntityDto } from 'src/Services/API/EntityLinks.api';

interface Variables {
  sourceType: LinkableEntityType;
  sourceId: string;
  targetType: LinkableEntityType;
  targetId: string;
}

const useCreateEntityLink = () => {
  const assetId = useCurrentAssetId();
  const queryClient = useQueryClient();

  return useMutation<LinkedEntityDto, unknown, Variables>(
    async variables => {
      if (!assetId) throw new Error('No assetId provided');
      return entityLinksApi.create(assetId, variables);
    },
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries(
          linkedEntitiesQueryKey(assetId, variables.sourceType, variables.sourceId)
        );
        queryClient.invalidateQueries(
          linkedEntitiesQueryKey(assetId, variables.targetType, variables.targetId)
        );
      },
    }
  );
};

export default useCreateEntityLink;
